import { nextTick } from 'vue';
import { emit } from '@/javascript/eventBus';

export const initializeRouter = async (router) => {
  await router.isReady();

  const workspaceId = router.currentRoute.value.query.workspace_id || '';
  if (workspaceId) {
    localStorage.setItem('billing_workspace_id', String(workspaceId));
  }

  const addCreditPack = router.currentRoute.value.query.credits_pack === 'true';
  if (addCreditPack) {
    localStorage.setItem('mainPage', 'manage_billing');
    emit('page_changed', { main_page: 'manage_billing' });
    await router.push('/manage_billing');
    nextTick(() => {
      emit('triggerClick', true);
    });
  }
};
